module.exports = __webpack_public_path__ + "static/media/boundbrook.f672a5c3.png";